// see https://www.cookiebot.com/en/developer/
import { useEffect, useState } from "react";

type ConsentState = {
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
  /** True once Cookiebot has loaded and the user's choice is known. */
  ready: boolean;
};

const INITIAL: ConsentState = {
  necessary: true,
  preferences: false,
  statistics: false,
  marketing: false,
  ready: false,
};

function readConsent(): ConsentState {
  const consent = window.Cookiebot?.consent;
  return {
    necessary: true,
    preferences: consent?.preferences || false,
    statistics: consent?.statistics || false,
    marketing: consent?.marketing || false,
    // Cookiebot exposes `hasResponse` once the banner has been answered.
    ready: !!(window.Cookiebot?.hasResponse ?? consent),
  };
}

const useConsent = () => {
  const [state, setState] = useState<ConsentState>(INITIAL);

  useEffect(() => {
    // Read initial consent after mount
    setState(readConsent());

    function update() {
      setState(readConsent());
    }
    window.addEventListener("CookiebotOnAccept", update);
    window.addEventListener("CookiebotOnDecline", update);
    return () => {
      window.removeEventListener("CookiebotOnAccept", update);
      window.removeEventListener("CookiebotOnDecline", update);
    };
  }, []);

  return state;
};

export { useConsent };
